var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoInfoCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8Zm.167 3.333a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm1.5 9H7A.667.667 0 1 1 7 11h.5a.167.167 0 0 0 .167-.167v-3a.167.167 0 0 0-.167-.166H7a.667.667 0 1 1 0-1.334h.667A1.333 1.333 0 0 1 9 7.667v3.166a.167.167 0 0 0 .167.167h.5a.667.667 0 1 1 0 1.333Z",
  fill: "#5A687B"
})));
export { SvgIcoInfoCircle as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico-info-circle.d86198c125535c59027f765e12321ad8.svg";